import React, { PropTypes, Component } from 'react';
import Translate from 'react-translate-component';
import { connect } from 'react-redux';

export class Error extends Component {

  static propTypes = {
    // Redux state
    error: PropTypes.object
  };

  render () {
    if (this.props.error !== null) {
      let keyError = null;

      if (this.props.error.key) {
        keyError = (
          <p className="error">
            <Translate content={this.props.error.key}/>
          </p>
        );
      }

      let errorMessages = [];

      if (this.props.error.messages) {
        for (let msg of this.props.error.messages) {
          errorMessages.push(
            (<p className="error">{msg}</p>)
          );
        }
      }

      return (
        <div>
          {keyError}
          {errorMessages}
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps (state) {
  return {
    error: state.bankId.error
  };
};

export default connect(mapStateToProps)(Error);



/** WEBPACK FOOTER **
 ** ./src/components/bank-id/error.js
 **/